import { Component, OnInit } from '@angular/core';
import { DevicepositionhistoryService } from '../../../@core/services/devicepositionhistory.service';
import { SectorService } from '../../../@core/services/sector.service';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { RouteCompress } from '../../../@core/models/live-route';

@Component({
  selector: 'device-history',
  templateUrl: './device-history.component.html',
  styleUrls: ['./device-history.component.scss']
})
export class DeviceHistoryComponent implements OnInit {
  // google maps zoom level
  zoom: number = 16;
  // initial center position for the map
  lat: number = 45.500922;
  lng: number = -73.443143;
  constructor(
    public apiProvider: ApiProvider,
    public _sectorService: SectorService,
    public _DevicepositionhistoryService: DevicepositionhistoryService
  ) {}

  ngOnInit() {
    this.setCurrentLocation();
  }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 15;
      });
    }
  }

  public selectItem(tab: RouteCompress) {
    this._DevicepositionhistoryService.RouteID = tab.Route_ID;
    this._DevicepositionhistoryService.RouteDate = this._sectorService.RouteDate;
    this._DevicepositionhistoryService.initialiseDevicepositionhistory();
  }
}
